import { useState, useEffect } from "react";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import {baseUrl,baseUrladmin} from "../../assets/js/config/config.js";

function Companytypes() {
  const AccessToken = localStorage.getItem("accessToken");
  const [posts, setCompanytypes] = useState([]);
  useEffect(() => {
    fetch(baseUrladmin + "apptypes/getAllAppTypes", {
      headers: {
        Authorization: `Bearer ${AccessToken}`,
        "Content-type": "application/json; charset=UTF-8",
        "companyId":  localStorage.getItem("companyId"),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setCompanytypes(data.data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, []);
  const rows = posts;
  const columns = [
    { Header: "companyType", accessor: "companyType", width: "45%", align: "left" },
    { Header: "companyTypeId", accessor: "companyTypeId", align: "left" },
    { Header: "companyTypeOrder", accessor: "companyTypeOrder", align: "center" },
  ];
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Company Types
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={1}
                  entriesPerPage={1}
                  showTotalEntries={1}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Companytypes;
